export const EmptyAnnouncement = {
        title: "",
        announcement_category: 0,
        content: "",
        creator: "",
        url: ""
}